import { StdResponse, coreAxios } from "@/declare/api/axios"
import { Task, TaskPublishLog } from "@/declare/interface/task";
import axios, { AxiosResponse } from "axios";
import qs from 'qs';

/**
 * 添加单个任务
 * @param task 
 * @param params 
 * @returns 
 */
export function addTask(task: Task, isPublish: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/tasks`, task, {
        params: {
            ...params,
            isPublish: isPublish,
        }
    })
}

/**
 * 添加多个任务
 * @param tasks 
 * @param params 
 * @returns 
 */
export function addTaskMulti(tasks: Task[], isPublish: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/tasks/multi`, tasks, {
        params: {
            ...params,
            isPublish: isPublish,
        }
    })
}

/**
 * 获得任务详情
 * @param id 
 * @param params 
 * @returns 
 */
export function getTask(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/tasks/${id}`, {
        params: params
    })
}

/**
 * 更新任务
 * @param id 
 * @param data 
 * @param params 
 * @returns 
 */
export function updateTask(id: number, data: {}, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/tasks/${id}`, data, {
        params: params
    })
}

/**
 * 删除单个任务
 * @param taskId 
 * @param params 
 * @returns 
 */
export function deleteTask(taskId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/tasks/${taskId}`, {
        params: params
    })
}
/**
 * 删除多个任务
 * @param taskIds 
 * @param params 
 * @returns 
 */
export function deleteTasks(taskIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/tasks/delete`, taskIds, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 获得任务列表
 * @param params 可选：institutionId, projectId, userId, unpublished, isFinish
 * @returns 
 */
export function getTasks(params?: {}): Promise<AxiosResponse<Task[]>> {
    return coreAxios.get(`/tasks`, {
        params: params,
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 
 * @param params 
 * @returns 
 */
export function getTaskListByTime(userId: number, startTime: number, endTime: number, params?: {}): Promise<AxiosResponse<Task[]>> {
    return coreAxios.get(`/users/${userId}/tasks/time`, {
        params: {
            startTime: startTime,
            endTime: endTime,
            ...params
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 获得任务发布记录
 * @param params projectId, userId
 * @returns 
 */
export function getTaskPublishLogs(projectId: number, userId: number, params?: {}): Promise<AxiosResponse<TaskPublishLog[]>> {
    return coreAxios.get(`/tasks/publish-logs`, {
        params: {
            ...params,
            projectId: projectId,
            userId: userId,
        }
    })
}

/**
 * 修改任务的经办人
 */
export function updateTaskTodoUser(taskId: number, userId: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/tasks/${taskId}/todo-change`, null, {
        params: {
            ...params,
            userId: userId,
        }
    })
}

